import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faq } from "@/data/siteContent";
import useScrollReveal from "@/hooks/useScrollReveal";
import SectionHeading from "@/components/SectionHeading";

export default function FAQ() {
  const ref = useScrollReveal({ y: 30, stagger: 0.08 });
  return (
    <section
      id="faq"
      ref={ref}
      className="border-t border-white/10 bg-[#080808]"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-3xl px-6 py-20 md:py-32">
        <SectionHeading
          reveal
          eyebrow={faq.eyebrow}
          title={faq.heading}
          className="mb-12 text-center"
        />

        <Accordion type="single" collapsible className="w-full" data-reveal>
          {faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 text-left font-display text-lg text-white hover:no-underline md:text-xl [&>svg]:text-white/50">
                <span style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{item.q}</span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 font-body text-base leading-relaxed text-white/70">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
